import { render } from "./SurfacePaysage.vue?vue&type=template&id=5cac09d8&scoped=true"
import script from "./SurfacePaysage.vue?vue&type=script&lang=js"
export * from "./SurfacePaysage.vue?vue&type=script&lang=js"

import "./SurfacePaysage.vue?vue&type=style&index=0&id=5cac09d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cac09d8"]])

export default __exports__